import { GetPatientByCpfOrName } from 'domain/usecases/patient/get-patient-by-cpf-or-name'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteGetPatientByCpfOrName implements GetPatientByCpfOrName {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params?: GetPatientByCpfOrName.Params
  ): Promise<GetPatientByCpfOrName.Model> {
    return this.patientRepository.getPatientByCpfOrName(params)
  }
}

export type GetPatientByCpfOrNameModel = GetPatientByCpfOrName.Model
